import numeral from 'numeral';
import { uuid } from 'vue-uuid';
import * as vega from 'vega';
import * as vegaTooltip from 'vega-tooltip';

export default {

    computed: {
        /**
         * Provides a unique identifier for each instance of this component.
         */
        displayDiv() {
            return `stackedvis-${uuid.v1()}`;
        },
    },

    methods: {
        /**
         * Create and run this component's vega view.
         */
        render() {
            const handler = new vegaTooltip.Handler();
            this.vegaView = new vega.View(vega.parse(this.vegaSpec), {
                renderer: 'svg',
                container: `#${this.displayDiv}`,
                hover: true,
                tooltip: handler.call,
            });
            this.vegaView.runAsync();
        },

        /**
         * Format the give number with the configured number of decimal places.
         */
        prepareNumberForTooltip(num) {
            if (!num) return num;

            let zeroes = '00';
            if (this.options && (this.options.roundToDecimalPlaces || this.options.roundToDecimalPlaces === 0)) {
                zeroes = '0'.repeat(this.options.roundToDecimalPlaces);
            }

            // to format with numeral, we pass a string in the "format" that we want
            // to put commas for thousands/millions/etc, we put '0,0'
            // to round to certain decimal place, we put that many zeroes after the decimal
            return numeral(num).format(`0,0.${zeroes}`);
        },
    },
};
